class ApiMock {
  setAuthHook = null;
  onApiError = null;

  constructor() {
  }

  setAuth(hook) {
    this.setAuthHook = hook;
  }

  async login(login, password) {
    console.log(login, password);
    return {
      'token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c',
    };
  }

  async getFeeds(from, to) {
    console.log(from, to);
    return [
      {
        'id': 4,
        'name': 'RexRTB main push',
        'type': 'push',
        'enabled': false,
        'rps': 3000,
        'countryFilters': {
          'white': 0,
          'black': 72,
        },
        'siteFilters': {
          'white': 0,
          'black': 0,
        },
        'userFilters': {
          'white': 0,
          'black': 0,
        },
        'discrep': 20,
        'countryDiscrep': {},
        'requests': 0,
        'responses': 0,
        'emptyResponses': 0,
        'errors': 0,
        'impressions': 0,
        'impressionsFromApi': 0,
        'impressionsDiscrep': 0,
        'clicks': 0,
        'clicksFromApi': 0,
        'clicksDiscrep': 0,
        'ctr': 0,
        'winRate': 0,
        'expense': 0,
        'income': 0,
        'note': 'TEST NOTE',
        'bidAvg': 0,
        'tookMsMin': 0,
        'tookMsMax': 0,
        'tookMsAvg': 0,
        'tookMsMedian': 0,
      }];
  }

  getChangelogs() {
    return [];
  }

  getCampaigns() {
    return {
      data: [
        {
          id: 1,
          format: 'push',
          feedId: 1,
          feedName: 'Фид 1',
          originalCampaignId: '',
          campaignId: 0,
          title: 'आज 50% की छूट! + 10 सेंटीमीटर',
          text: '0 दिनों में 10 सेंटीमीटर! -50% आज!',
          url: 'https://partners-tds.com/Lwqcfz',
          parsedIconUrl: 'https://img.cdn.house/files/ads/335/def_icon.png',
          parsedImageUrl: 'https://img.cdn.house/files/ads/335/def_img.png',
          parsedPageUrl: '',
        },
        {
          id: 2,
          format: 'push',
          feedId: 2,
          feedName: 'Фид 2',
          originalCampaignId: '',
          campaignId: 0,
          title: 'आज 50% की छूट! + 10 सेंटीमीटर',
          text: '0 दिनों में 10 सेंटीमीटर! -50% आज!',
          url: 'https://partners-tds.com/Lwqcfz',
          parsedIconUrl: 'https://img.cdn.house/files/ads/335/def_icon.png',
          parsedImageUrl: 'https://img.cdn.house/files/ads/335/def_img.png',
          parsedPageUrl: '',
        },
        {
          id: 3,
          format: 'push',
          feedId: 3,
          feedName: 'Фид 3',
          originalCampaignId: '',
          campaignId: 0,
          title: 'आज 50% की छूट! + 10 सेंटीमीटर',
          text: '0 दिनों में 10 सेंटीमीटर! -50% आज!',
          url: 'https://partners-tds.com/Lwqcfz',
          parsedIconUrl: 'https://img.cdn.house/files/ads/335/def_icon.png',
          parsedImageUrl: 'https://img.cdn.house/files/ads/335/def_img.png',
          parsedPageUrl: '',
        },
      ],
      metadata: {
        total: 3,
      },
    };
  }

  async getFeed(id) {
    console.log(id);
    if (id === 4) {
      return {
        'id': 4,
        'name': 'RexRTB main push',
        'enabled': false,
        'type': 'push',
        'token': '72ef763407a0d94094183405eedfc344',
        'parser': 'rexRtb',
        'rps': 3000,
        'discrep': 20,
        'countryDiscrep': {},
        'endpoint': 'http://eu.xml.rexsrv.com/bid/1647/TOKEN?ip={ip}\u0026ua={ua}\u0026source={subAcc}\u0026sub_id={userId}\u0026kw=test\u0026lang={lang}\u0026dt_sub={userRegDateYmd}\u0026dt_sub_ts={userRegTs}\u0026subscriber_id={subscriptionId}\u0026subscriber_age={userRegAgeDays}\u0026limit=5\u0026format=json\u0026traffic_type=1',
        'isAdult': false,
        'countryWhitelist': {
          'color': 'White',
          'items': [],
        },
        'countryBlacklist': {
          'color': 'Black',
          'items': [
            'AD',
            'AE',
            'AL',
            'AO',
            'AX',
            'AZ',
            'BA',
            'BB',
            'BG',
            'BJ',
            'BW',
            'BY',
            'CH',
            'CO',
            'CZ',
            'EC',
            'EE',
            'EG',
            'FI',
            'FJ',
            'FK',
            'FO',
            'GA',
            'GE',
            'GF',
            'GP',
            'GT',
            'GY',
            'HU',
            'IM',
            'IQ',
            'JM',
            'JO',
            'KG',
            'KY',
            'KZ',
            'LA',
            'LB',
            'LI',
            'LU',
            'MA',
            'ME',
            'MN',
            'MQ',
            'MR',
            'MT',
            'MU',
            'MV',
            'MY',
            'MZ',
            'NC',
            'NG',
            'PE',
            'PF',
            'PL',
            'PS',
            'PT',
            'PY',
            'RE',
            'RO',
            'RS',
            'SA',
            'SE',
            'SL',
            'SV',
            'TC',
            'TJ',
            'TM',
            'TT',
            'XK',
            'YE',
            'ZW'],
        },
        'siteWhitelist': {
          'color': 'White',
          'items': [],
        },
        'siteBlacklist': {
          'color': 'Black',
          'items': [],
        },
        'userWhitelist': {
          'color': 'White',
          'items': [],
        },
        'userBlacklist': {
          'color': 'Black',
          'items': [],
        },
        'note': 'TEST NOTE',
      };
    }
    throw new Error('bad id');
  }

  async createFeed(feed) {
    console.log(feed);
    throw new Error('not implemented in mock');
  }

  async updateFeed(feed) {
    console.log(feed);
    throw new Error('not implemented in mock');
  }

  async saveFeed(feed) {
    if (feed.id) {
      return this.updateFeed(feed);
    } else {
      return this.createFeed(feed);
    }
  }

  async getVariables() {
    return [
      {
        'name': 'countryIso',
        'description': 'Country ISO code',
        'example': 'UA',
      }, {
        'name': 'ip',
        'description': 'User IP',
        'example': '69.162.81.155',
      }, {
        'name': 'lang',
        'description': 'User/browser language',
        'example': 'en',
      }, {
        'name': 'subAcc',
        'description': 'Source of traffic',
        'example': '3047171',
      }, {
        'name': 'subscriptionId',
        'description': 'Unique ID of subscription',
        'example': '3898135400',
      }, {
        'name': 'ua',
        'description': 'User browser (User-Agent header)',
        'example': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/100.0.4896.88 Safari/537.36',
      }, {
        'name': 'userId',
        'description': 'Web user ID',
        'example': '135400',
      }, {
        'name': 'userRegAgeDays',
        'description': 'Age of user subscription in days (starts from 0)',
        'example': '365',
      }, {
        'name': 'userRegDateYmd',
        'description': 'Registration date of user subscription',
        'example': '2006-01-02',
      }, {
        'name': 'userRegTs',
        'description': 'Registration timestamp of user subscription',
        'example': '1650367603',
      }];
  }

  async getTypes() {
    return {
      'inpage': 'InPage',
      'push': 'Push',
    };
  }

  async getStatistics(filters) {
    console.log(filters);
    return {
      'filters': [
        {
          'id': 'groupBy',
          'values': [
            {
              'label': 'По дням',
              'value': 'day',
            }, {
              'label': 'По часам',
              'value': 'hour',
            }, {
              'label': 'По фидам',
              'value': 'feed',
            }, {
              'label': 'По странам',
              'value': 'country',
            }, {
              'label': 'По браузерам',
              'value': 'browser',
            }, {
              'label': 'По системам',
              'value': 'os',
            }, {
              'label': 'По типам',
              'value': 'type',
            }, {
              'label': 'По пользователям',
              'value': 'user',
            }, {
              'label': 'По площадкам',
              'value': 'site',
            }, {
              'label': 'По устройствам',
              'value': 'device',
            }],
        }, {
          'id': 'feed',
          'values': [
            {
              'label': 'Все фиды',
              'value': '',
            }, {
              'label': 'RexRTB main push',
              'value': '4',
            }, {
              'label': 'Adoperator.com e928 push',
              'value': '5',
            }, {
              'label': 'Adeum main push',
              'value': '6',
            }, {
              'label': 'Adeum push adult',
              'value': '7',
            }, {
              'label': 'RollerAds main push',
              'value': '8',
            }, {
              'label': 'RichAds push main',
              'value': '10',
            }, {
              'label': 'Clickadilla',
              'value': '13',
            }, {
              'label': 'Galaksion',
              'value': '16',
            }],
        }, {
          'id': 'country',
          'values': [
            {
              'label': 'Все страны',
              'value': '',
            }, {
              'label': 'Алжир',
              'value': 'DZ',
            }, {
              'label': 'Тунис',
              'value': 'TN',
            }, {
              'label': 'Йемен',
              'value': 'YE',
            }, {
              'label': 'Монтсеррат',
              'value': 'MS',
            }, {
              'label': 'Токелау',
              'value': 'TK',
            }, {
              'label': 'Науру',
              'value': 'NR',
            }, {
              'label': 'Панама',
              'value': 'PA',
            }, {
              'label': 'Того',
              'value': 'TG',
            }, {
              'label': 'Украина',
              'value': 'UA',
            }, {
              'label': 'Гернси',
              'value': 'GG',
            }, {
              'label': 'Румыния',
              'value': 'RO',
            }, {
              'label': 'Бутан',
              'value': 'BT',
            }, {
              'label': 'Перу',
              'value': 'PE',
            }, {
              'label': 'Нидерланды',
              'value': 'NL',
            }, {
              'label': 'Папуа - Новая Гвинея',
              'value': 'PG',
            }, {
              'label': 'остров Святой Елены',
              'value': 'SH',
            }, {
              'label': 'Словакия',
              'value': 'SK',
            }, {
              'label': 'Западная Сахара',
              'value': 'EH',
            }, {
              'label': 'Исландия',
              'value': 'IS',
            }, {
              'label': 'Андорра',
              'value': 'AD',
            }, {
              'label': 'Колумбия',
              'value': 'CO',
            }, {
              'label': 'Зимбабве',
              'value': 'ZW',
            }, {
              'label': 'Гваделупа',
              'value': 'GP',
            }, {
              'label': 'Бонэйр, Синт-Эстатиус и Саба',
              'value': 'BQ',
            }, {
              'label': 'Латвия',
              'value': 'LV',
            }, {
              'label': 'Британские территории Индийского океана',
              'value': 'IO',
            }, {
              'label': 'Камбоджа',
              'value': 'KH',
            }, {
              'label': 'Бангладеш',
              'value': 'BD',
            }, {
              'label': 'Сейшельские острова',
              'value': 'SC',
            }, {
              'label': 'Судан',
              'value': 'SD',
            }, {
              'label': 'Чили',
              'value': 'CL',
            }, {
              'label': 'Мавритания',
              'value': 'MR',
            }, {
              'label': 'Парагвай',
              'value': 'PY',
            }, {
              'label': 'Польша',
              'value': 'PL',
            }, {
              'label': 'Экваториальная Гвинея',
              'value': 'GQ',
            }, {
              'label': 'Остров Мэн',
              'value': 'IM',
            }, {
              'label': 'Мартиника',
              'value': 'MQ',
            }, {
              'label': 'Китайская Народная Республика',
              'value': 'CN',
            }, {
              'label': 'Иран',
              'value': 'IR',
            }, {
              'label': 'Майотта',
              'value': 'YT',
            }, {
              'label': 'Тайвань (Республика Китай)',
              'value': 'TW',
            }, {
              'label': 'Соединенные Штаты Америки',
              'value': 'US',
            }, {
              'label': 'Кюрасао',
              'value': 'CW',
            }, {
              'label': 'Французская Полинезия',
              'value': 'PF',
            }, {
              'label': 'Марианские острова',
              'value': 'MP',
            }, {
              'label': 'Никарагуа',
              'value': 'NI',
            }, {
              'label': 'Кипр',
              'value': 'CY',
            }, {
              'label': 'Маршалловы острова',
              'value': 'MH',
            }, {
              'label': 'Буркина Фасо',
              'value': 'BF',
            }, {
              'label': 'Казахстан',
              'value': 'KZ',
            }, {
              'label': 'острова Самоа',
              'value': 'WS',
            }, {
              'label': 'Каймановы острова',
              'value': 'KY',
            }, {
              'label': 'Нигер',
              'value': 'NE',
            }, {
              'label': 'Болгария',
              'value': 'BG',
            }, {
              'label': 'Беларусь',
              'value': 'BY',
            }, {
              'label': 'Демократическая республика Конго',
              'value': 'CD',
            }, {
              'label': 'Соломоновы острова',
              'value': 'SB',
            }, {
              'label': 'Катар',
              'value': 'QA',
            }, {
              'label': 'Монако',
              'value': 'MC',
            }, {
              'label': 'Багамские острова',
              'value': 'BS',
            }, {
              'label': 'Турция',
              'value': 'TR',
            }, {
              'label': 'Индия',
              'value': 'IN',
            }, {
              'label': 'Венесуэла',
              'value': 'VE',
            }, {
              'label': 'Сент-Винсент и Гренадины',
              'value': 'VC',
            }, {
              'label': 'Суринам',
              'value': 'SR',
            }, {
              'label': 'Тувалу',
              'value': 'TV',
            }, {
              'label': 'Пакистан',
              'value': 'PK',
            }, {
              'label': 'Таджикистан',
              'value': 'TJ',
            }, {
              'label': 'Кувейт',
              'value': 'KW',
            }, {
              'label': 'Коста Рика',
              'value': 'CR',
            }, {
              'label': 'Шри Ланка',
              'value': 'LK',
            }, {
              'label': 'Мозамбик',
              'value': 'MZ',
            }, {
              'label': 'Сент-Люсия',
              'value': 'LC',
            }, {
              'label': 'Оман',
              'value': 'OM',
            }, {
              'label': 'Египет',
              'value': 'EG',
            }, {
              'label': 'Черногория',
              'value': 'ME',
            }, {
              'label': 'Белиз',
              'value': 'BZ',
            }, {
              'label': 'Ватикан',
              'value': 'VA',
            }, {
              'label': 'Литва',
              'value': 'LT',
            }, {
              'label': 'Узбекистан',
              'value': 'UZ',
            }, {
              'label': 'Эфиопия',
              'value': 'ET',
            }, {
              'label': 'Израиль',
              'value': 'IL',
            }, {
              'label': 'Сан-Томе и Принсипи',
              'value': 'ST',
            }, {
              'label': 'Руанда',
              'value': 'RW',
            }, {
              'label': 'Новая Каледония',
              'value': 'NC',
            }, {
              'label': 'Кот-д`Ивуар',
              'value': 'CI',
            }, {
              'label': 'Гуам',
              'value': 'GU',
            }, {
              'label': 'Индонезия',
              'value': 'ID',
            }, {
              'label': 'острова Валлис и Футуна',
              'value': 'WF',
            }, {
              'label': 'Ливан',
              'value': 'LB',
            }, {
              'label': 'Намибия',
              'value': 'NA',
            }, {
              'label': 'Гайана',
              'value': 'GY',
            }, {
              'label': 'Ангилья',
              'value': 'AI',
            }, {
              'label': 'Филиппины',
              'value': 'PH',
            }, {
              'label': 'Хорватия',
              'value': 'HR',
            }, {
              'label': 'Монголия',
              'value': 'MN',
            }, {
              'label': 'Мьянма',
              'value': 'MM',
            }, {
              'label': 'Словения',
              'value': 'SI',
            }, {
              'label': 'Кыргызстан',
              'value': 'KG',
            }, {
              'label': 'Бахрейн',
              'value': 'BH',
            }, {
              'label': 'Ирак',
              'value': 'IQ',
            }, {
              'label': 'Бурунди',
              'value': 'BI',
            }, {
              'label': 'Босния и Герцеговина',
              'value': 'BA',
            }, {
              'label': 'Аруба',
              'value': 'AW',
            }, {
              'label': 'Германия',
              'value': 'DE',
            }, {
              'label': 'Сомали',
              'value': 'SO',
            }, {
              'label': 'Сирия',
              'value': 'SY',
            }, {
              'label': 'Чехия',
              'value': 'CZ',
            }, {
              'label': 'Финляндия',
              'value': 'FI',
            }, {
              'label': 'Армения',
              'value': 'AM',
            }, {
              'label': 'Бельгия',
              'value': 'BE',
            }, {
              'label': 'Азербайджан',
              'value': 'AZ',
            }, {
              'label': 'Франция',
              'value': 'FR',
            }, {
              'label': 'Мальдивские острова',
              'value': 'MV',
            }, {
              'label': 'Афганистан',
              'value': 'AF',
            }, {
              'label': 'Иордания',
              'value': 'JO',
            }, {
              'label': 'Сальвадор',
              'value': 'SV',
            }, {
              'label': 'Американский Самоа',
              'value': 'AS',
            }, {
              'label': 'Либерия',
              'value': 'LR',
            }, {
              'label': 'Фолклендские (Мальвинские) острова',
              'value': 'FK',
            }, {
              'label': 'Лаос',
              'value': 'LA',
            }, {
              'label': 'Бермуды',
              'value': 'BM',
            }, {
              'label': 'Албания',
              'value': 'AL',
            }, {
              'label': 'Кирибати',
              'value': 'KI',
            }, {
              'label': 'острова Кука',
              'value': 'CK',
            }, {
              'label': 'Мексика',
              'value': 'MX',
            }, {
              'label': 'Лесото',
              'value': 'LS',
            }, {
              'label': 'Макао (Китай)',
              'value': 'MO',
            }, {
              'label': 'Эритрея',
              'value': 'ER',
            }, {
              'label': 'Гонконг (Китай)',
              'value': 'HK',
            }, {
              'label': 'острова Туркс и Кайкос',
              'value': 'TC',
            }, {
              'label': 'Непал',
              'value': 'NP',
            }, {
              'label': 'Ниуэ',
              'value': 'NU',
            }, {
              'label': 'Микронезия',
              'value': 'FM',
            }, {
              'label': 'Сьерра-Леоне',
              'value': 'SL',
            }, {
              'label': 'Эстония',
              'value': 'EE',
            }, {
              'label': 'Танзания',
              'value': 'TZ',
            }, {
              'label': 'Мальта',
              'value': 'MT',
            }, {
              'label': 'Южный Судан',
              'value': 'SS',
            }, {
              'label': 'Фиджи',
              'value': 'FJ',
            }, {
              'label': 'Ирландия',
              'value': 'IE',
            }, {
              'label': 'Лихтенштейн',
              'value': 'LI',
            }, {
              'label': 'Палестина',
              'value': 'PS',
            }, {
              'label': 'Малави',
              'value': 'MW',
            }, {
              'label': 'Швейцария',
              'value': 'CH',
            }, {
              'label': 'Македония',
              'value': 'MK',
            }, {
              'label': 'Габон',
              'value': 'GA',
            }, {
              'label': 'Антигуа и Барбуда',
              'value': 'AG',
            }, {
              'label': 'Ямайка',
              'value': 'JM',
            }, {
              'label': 'Центральная Африканская Республика',
              'value': 'CF',
            }, {
              'label': 'Замбия',
              'value': 'ZM',
            }, {
              'label': 'Нигерия',
              'value': 'NG',
            }, {
              'label': 'острова Свалбард и Ян Майен',
              'value': 'SJ',
            }, {
              'label': 'Австрия',
              'value': 'AT',
            }, {
              'label': 'Люксембург',
              'value': 'LU',
            }, {
              'label': 'Чад',
              'value': 'TD',
            }, {
              'label': 'Джибути',
              'value': 'DJ',
            }, {
              'label': 'Сербия',
              'value': 'RS',
            }, {
              'label': 'Синт-Мартен',
              'value': 'SX',
            }, {
              'label': 'Ботсвана',
              'value': 'BW',
            }, {
              'label': 'Австралия',
              'value': 'AU',
            }, {
              'label': 'Бразилия',
              'value': 'BR',
            }, {
              'label': 'Уганда',
              'value': 'UG',
            }, {
              'label': 'Венгрия',
              'value': 'HU',
            }, {
              'label': 'Сен-Бартелеми',
              'value': 'BL',
            }, {
              'label': 'Свазиленд',
              'value': 'SZ',
            }, {
              'label': 'Марокко',
              'value': 'MA',
            }, {
              'label': 'Кения',
              'value': 'KE',
            }, {
              'label': 'Молдова',
              'value': 'MD',
            }, {
              'label': 'Тайланд',
              'value': 'TH',
            }, {
              'label': 'Уругвай',
              'value': 'UY',
            }, {
              'label': 'Гибралтар',
              'value': 'GI',
            }, {
              'label': 'Конго',
              'value': 'CG',
            }, {
              'label': 'Швеция',
              'value': 'SE',
            }, {
              'label': 'Дания',
              'value': 'DK',
            }, {
              'label': 'Эквадор',
              'value': 'EC',
            }, {
              'label': 'Грузия',
              'value': 'GE',
            }, {
              'label': 'Гвинея-Бисау',
              'value': 'GW',
            }, {
              'label': 'Япония',
              'value': 'JP',
            }, {
              'label': 'Аргентина',
              'value': 'AR',
            }, {
              'label': 'Восточный Тимор',
              'value': 'TL',
            }, {
              'label': 'Гамбия',
              'value': 'GM',
            }, {
              'label': 'Тринидад и Тобаго',
              'value': 'TT',
            }, {
              'label': 'Великобритания',
              'value': 'GB',
            }, {
              'label': 'Корея',
              'value': 'KR',
            }, {
              'label': 'острова Зеленого Мыса',
              'value': 'CV',
            }, {
              'label': 'Португалия',
              'value': 'PT',
            }, {
              'label': 'Греция',
              'value': 'GR',
            }, {
              'label': 'Мали',
              'value': 'ML',
            }, {
              'label': 'Гватемала',
              'value': 'GT',
            }, {
              'label': 'Ливия',
              'value': 'LY',
            }, {
              'label': 'Гренландия',
              'value': 'GL',
            }, {
              'label': 'Бруней',
              'value': 'BN',
            }, {
              'label': 'Норвегия',
              'value': 'NO',
            }, {
              'label': 'Гаити',
              'value': 'HT',
            }, {
              'label': 'ЮАР',
              'value': 'ZA',
            }, {
              'label': 'Малайзия',
              'value': 'MY',
            }, {
              'label': 'остров Норфолк',
              'value': 'NF',
            }, {
              'label': 'Мадагаскар',
              'value': 'MG',
            }, {
              'label': 'Тонга',
              'value': 'TO',
            }, {
              'label': 'Коморские острова',
              'value': 'KM',
            }, {
              'label': 'Доминиканская республика',
              'value': 'DO',
            }, {
              'label': 'Гана',
              'value': 'GH',
            }, {
              'label': 'Маврикий',
              'value': 'MU',
            }, {
              'label': 'Италия',
              'value': 'IT',
            }, {
              'label': 'Джерси',
              'value': 'JE',
            }, {
              'label': 'Сен-Мартен',
              'value': 'MF',
            }, {
              'label': 'Сент-Китс и Невис',
              'value': 'KN',
            }, {
              'label': 'Камерун',
              'value': 'CM',
            }, {
              'label': 'Отдаленные Острова США',
              'value': 'UM',
            }, {
              'label': 'Бенин',
              'value': 'BJ',
            }, {
              'label': 'Гондурас',
              'value': 'HN',
            }, {
              'label': 'Сенегал',
              'value': 'SN',
            }, {
              'label': 'Сингапур',
              'value': 'SG',
            }, {
              'label': 'Сен-Пьер и Микелон',
              'value': 'PM',
            }, {
              'label': 'Куба',
              'value': 'CU',
            }, {
              'label': 'Вануату',
              'value': 'VU',
            }, {
              'label': 'Французская Гвиана',
              'value': 'GF',
            }, {
              'label': 'Палау',
              'value': 'PW',
            }, {
              'label': 'Канада',
              'value': 'CA',
            }, {
              'label': 'Гвинея',
              'value': 'GN',
            }, {
              'label': 'Россия',
              'value': 'RU',
            }, {
              'label': 'Доминика',
              'value': 'DM',
            }, {
              'label': 'Вьетнам',
              'value': 'VN',
            }, {
              'label': 'Виргинские острова (США)',
              'value': 'VI',
            }, {
              'label': 'Реюньон',
              'value': 'RE',
            }, {
              'label': 'Арабские Эмираты',
              'value': 'AE',
            }, {
              'label': 'Саудовская Аравия',
              'value': 'SA',
            }, {
              'label': 'Виргинские острова (Британские)',
              'value': 'VG',
            }, {
              'label': 'Косово',
              'value': 'XK',
            }, {
              'label': 'Гренада',
              'value': 'GD',
            }, {
              'label': 'Барбадос',
              'value': 'BB',
            }, {
              'label': 'Аландские острова',
              'value': 'AX',
            }, {
              'label': 'Пуэрто-Рико',
              'value': 'PR',
            }, {
              'label': 'Туркменистан',
              'value': 'TM',
            }, {
              'label': 'Испания',
              'value': 'ES',
            }, {
              'label': 'Сан-Марино',
              'value': 'SM',
            }, {
              'label': 'Ангола',
              'value': 'AO',
            }, {
              'label': 'Новая Зеландия',
              'value': 'NZ',
            }, {
              'label': 'Фарерские острова',
              'value': 'FO',
            }, {
              'label': 'Боливия',
              'value': 'BO',
            }],
        }, {
          'id': 'browser',
          'values': [
            {
              'label': 'Все браузеры',
              'value': '',
            }, {
              'label': 'QQ',
              'value': 'QQ',
            }, {
              'label': 'Opera',
              'value': 'Opera',
            }, {
              'label': 'Android',
              'value': 'Android',
            }, {
              'label': 'Unknown',
              'value': 'Unknown',
            }, {
              'label': 'IE',
              'value': 'IE',
            }, {
              'label': 'Firefox',
              'value': 'Firefox',
            }, {
              'label': 'CocCoc',
              'value': 'CocCoc',
            }, {
              'label': 'Silk',
              'value': 'Silk',
            }, {
              'label': 'Samsung',
              'value': 'Samsung',
            }, {
              'label': 'GoogleBot',
              'value': 'GoogleBot',
            }, {
              'label': 'UCBrowser',
              'value': 'UCBrowser',
            }, {
              'label': 'Blackberry',
              'value': 'Blackberry',
            }, {
              'label': 'Chrome',
              'value': 'Chrome',
            }, {
              'label': 'PingdomBot',
              'value': 'PingdomBot',
            }, {
              'label': 'Yandex',
              'value': 'Yandex',
            }, {
              'label': 'Safari',
              'value': 'Safari',
            }],
        }, {
          'id': 'os',
          'values': [
            {
              'label': 'Все системы',
              'value': '',
            }, {
              'label': 'ChromeOS',
              'value': 'ChromeOS',
            }, {
              'label': 'iOS',
              'value': 'iOS',
            }, {
              'label': 'Linux',
              'value': 'Linux',
            }, {
              'label': 'Windows',
              'value': 'Windows',
            }, {
              'label': 'Android',
              'value': 'Android',
            }, {
              'label': 'Unknown',
              'value': 'Unknown',
            }, {
              'label': 'MacOSX',
              'value': 'MacOSX',
            }, {
              'label': 'Bot',
              'value': 'Bot',
            }, {
              'label': 'Kindle',
              'value': 'Kindle',
            }],
        }, {
          'id': 'type',
          'values': [
            {
              'label': 'Все типы',
              'value': '',
            }, {
              'label': 'push',
              'value': 'push',
            }, {
              'label': 'inpage',
              'value': 'inpage',
            }],
        }, {
          'id': 'user',
          'values': [
            {
              'label': 'Все пользователи',
              'value': '',
            }, {
              'label': '135400',
              'value': '135400',
            }, {
              'label': '135486',
              'value': '135486',
            }, {
              'label': '135488',
              'value': '135488',
            }, {
              'label': '135489',
              'value': '135489',
            }, {
              'label': '144073',
              'value': '144073',
            }, {
              'label': '144076',
              'value': '144076',
            }, {
              'label': '144078',
              'value': '144078',
            }, {
              'label': '144085',
              'value': '144085',
            }, {
              'label': '144086',
              'value': '144086',
            }, {
              'label': '144088',
              'value': '144088',
            }, {
              'label': '167449',
              'value': '167449',
            }, {
              'label': '167471',
              'value': '167471',
            }],
        }, {
          'id': 'site',
          'values': [
            {
              'label': 'Все площадки',
              'value': '',
            }, {
              'label': '1001569',
              'value': '1001569',
            }, {
              'label': '1001571',
              'value': '1001571',
            }, {
              'label': '1001572',
              'value': '1001572',
            }, {
              'label': '1001601',
              'value': '1001601',
            }, {
              'label': '1001619',
              'value': '1001619',
            }, {
              'label': '1001647',
              'value': '1001647',
            }, {
              'label': '1001660',
              'value': '1001660',
            }, {
              'label': '1001689',
              'value': '1001689',
            }, {
              'label': '1001702',
              'value': '1001702',
            }],
        }, {
          'id': 'device',
          'values': [
            {
              'label': 'Все устройства',
              'value': '',
            }, {
              'label': 'PC',
              'value': 'PC',
            }, {
              'label': 'Mobile',
              'value': 'Mobile',
            }],
        }],
      'data': [
        {
          'date': '2022-12-28',
          'requests': 39762638,
          'filledRequests': 34057683,
          'feedRequests': 91095649,
          'feedResponses': 38451147,
          'feedEmptyResponses': 52153106,
          'feedErrors': 491396,
          'covered': 85.65247356073307,
          'fillRate': 42.20964164819771,
          'bidAvg': 0.004214847267203709,
          'impressions': 4933647,
          'clicks': 1865,
          'ctr': 0.03780165058424326,
          'sent': 7.846883652460997,
          'received': 6.380377697727417,
          'difference': -1.46650595473358,
          'winRate': 5.415897525467984,
          'cpcAvg': 0.004207444317673457,
          'tookMsMin': 0,
          'tookMsMax': 0,
          'tookMsAvg': 0,
          'tookMsMedian': 0,
        }],
    };
  }

  async getParsers() {
    return [
      'adeum', 'rollerads', 'richads', 'galaksion', 'rexRtb', 'adopexchange'];
  }
}

export default ApiMock;
